/* eslint-disable @typescript-eslint/no-explicit-any */
import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";
import { MetaData } from "../Courses/GetAllRequests";

export type StudentsDTO = {
  id: string;
  email: string;
  fullName: string;
  phone: string;
  country: string;
  status: string;
  frozen: boolean;
  subscriptionEndsAt: number;
}

interface StudentsData {
  data: StudentsDTO[];
  metaData: MetaData;
}

interface StudentsResponse {
  data?: StudentsData;
  error?: ApiError;
}

interface GetStudentsParams {
  page: number;
  limit: number;
  firstName?: string;
  status?: string;
  phone?: string;
  email?: string;
  courseId: string
}

export const getStudentsbyCourse = async ({ page, limit, firstName, status, phone, email, courseId }: GetStudentsParams): Promise<StudentsResponse> => {
  try {
    const response = await axios.get(`/student/getAllStudentsByCourse/${courseId}`, {
      params: { page, limit, firstName, status, phone, email },
    });
    return { data: response.data };
  } catch (error: any) {
    console.error("API Error:", error);
    if (error.response) {
      const apiError: ApiError = {
        statusCode: error.response.status,
        message: error.response.data.message,
        error: error.response.data.error,
      };
      return { error: apiError };
    } else {
      const fallbackError: ApiError = {
        statusCode: 500,
        message: "An unexpected error occurred",
      };
      return { error: fallbackError };
    }
  }
};
